import PropTypes from "prop-types";

// project import
import useAuth from "hooks/useAuth";
import { useState } from "react";
import { useEffect } from "react";

// ==============================|| AUTH GUARD ||============================== //

const PermissionGuard = ({ permission, children }) => {
  const { user } = useAuth();
  const [userCanAccess, setUserCanAccess] = useState(null);

  useEffect(() => {
    if (user) {
      const checkUserHasPerm = user.user_permissions.findIndex(
        (perm) => perm.codename === permission
      );
      const canAccess = user.is_superuser || checkUserHasPerm !== -1;
      setUserCanAccess(canAccess);
    }
  }, [user, permission]);

  return (
    <>
      {userCanAccess === false && <p>You don't have access to this page!</p>}
      {userCanAccess && children}
    </>
  );
};

PermissionGuard.propTypes = {
  permission: PropTypes.string,
  children: PropTypes.node,
};

export default PermissionGuard;
